import search from './search';
import { attachEventListeners } from './ui';

import 'instantsearch.css/themes/reset.css';

search.start();
attachEventListeners();
